module.exports = __webpack_public_path__ + "img/imgduihjl-xz.4c196315.png";